import "./styles.css";
import React, { useState, useEffect } from "react";
import Header from "./components/header";
import RowView from "./components/rowView";
import NavBar from "./components/navbar";
import Footer from "./components/footer";
import Preloader from "./components/Preloader";
import {
  getTrending,
  getNowPlaying,
  getTopRatedMovies,
  discoverMovies,
  getTrending as getTrendingTV,
} from "./services/tmdb";

export default function App() {
  const [loaded, setLoaded] = useState(false);
  const [heroItems, setHeroItems] = useState([]);
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [trendingSeries, setTrendingSeries] = useState([]);
  const [nowPlaying, setNowPlaying] = useState([]);
  const [topRated, setTopRated] = useState([]);
  const [bollywood, setBollywood] = useState([]);

  useEffect(() => {
    async function fetchAll() {
      const [hero, movies, series, playing, top, bolly] = await Promise.all([
        getTrending("all", "week"),
        getTrending("movie", "week"),
        getTrendingTV("tv", "week"),
        getNowPlaying(),
        getTopRatedMovies(),
        discoverMovies({ with_original_language: "hi" }),
      ]);
      setHeroItems(hero?.results || []);
      setTrendingMovies(movies?.results || []);
      setTrendingSeries(series?.results || []);
      setNowPlaying(playing?.results || []);
      setTopRated(top?.results || []);
      setBollywood(bolly?.results || []);
    }
    fetchAll();
  }, []);

  return (
    <div className="App">
      {!loaded && <Preloader onFinish={() => setLoaded(true)} />}
      <NavBar home="active" />
      <Header items={heroItems} />
      <RowView heading="🔥 Trending Movies" items={trendingMovies} />
      <RowView heading="📺 Trending Series" items={trendingSeries} />
      <RowView heading="🎬 Now Playing in Theaters" items={nowPlaying} />
      <RowView heading="⭐ Top Rated Movies" items={topRated} />
      <RowView heading="🇮🇳 Bollywood Hits" items={bollywood} />
      <hr style={{ color: "white" }}></hr>
      <Footer />
    </div>
  );
}
